import React from 'react';
import { QuoteIcon, UserRoundIcon } from 'lucide-react';
import { SectionCta } from './CtaButton';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white px-5 py-16 sm:py-20" aria-labelledby="testimonials-title" data-id="element-232" data-mp="3fz5o5y3dnkgs">
      <div className="mx-auto max-w-6xl" data-id="element-233" data-mp="3b0ucrixfp1wg">
        <div className="mx-auto max-w-3xl text-center" data-id="element-234" data-mp="3b01hpf7u80u5">
          <h2 id="testimonials-title" className="text-[28px] font-black leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-235" data-mp="36yplgqugkhcz">
            WHAT OTHER PROFESSIONALS ARE SAYING
          </h2>
          <p className="mt-4 text-[17px] leading-relaxed text-muted" data-id="element-236" data-mp="2x0tgyhw10knu">
            We want you to be able to evaluate this collection based on transparent information. Customer feedback will be published here as verified reviews become available.
          </p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-237" data-mp="v7c9be7wbjt3">
          {testimonials.map((t, i) => <figure key={i} className="flex flex-col rounded-3xl bg-cream p-6" data-id="element-238" data-mp="q8irj9lkt6n4" data-mpi={i}>
              <QuoteIcon className="h-8 w-8 text-teal" aria-hidden="true" data-id="element-239" data-mp="h817no7u2gkh" />
              <blockquote className="mt-4 flex-1 text-[17px] font-medium leading-relaxed text-ink" data-id="element-240" data-mp="m5t14mo4maqs">{t.quote}</blockquote>
              <figcaption className="mt-6 flex items-center gap-4 border-t border-navy/10 pt-5" data-id="element-241" data-mp="79v6j8tupego">
                {t.photo ? <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-white" data-id="element-242" data-mp="zwponz3741qz" /> : <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full border-2 border-dashed border-navy/25 bg-white text-navy/40" data-id="element-243" data-mp="14uzkmbwqv6dn">
                    <UserRoundIcon className="h-7 w-7" aria-hidden="true" data-id="element-244" data-mp="v57lr5hm3r3d" />
                  </span>}
                <div data-id="element-245" data-mp="1iu9019d4lwgk">
                  <p className="font-extrabold text-ink" data-id="element-246" data-mp="1itqxxw3s8o0q">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-247" data-mp="1nma6genm4syo">{t.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <SectionCta label="Get your copy for $27" data-id="element-248" data-mp="1xfmtf4qgmpso" />
      </div>
    </section>;
}